"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function transform(model) {
    return {
        clientSource: model.ClientSource,
        inviterName: model.InviterName,
        inviterSkypeId: model.InviterSkypeId,
        longId: model.LongId,
    };
}
exports.transform = transform;
